<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body fluid="xl">
      <b-row class="text-center">
        <b-col cols="12">
            <h2><b-badge variant="info">New Patient Form</b-badge></h2>
        </b-col>
      </b-row>
      <b-form @submit.stop.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

       <b-row>
         <b-col>
         <b-form-group label="Name" label-for="name" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="name" :state="validateState('name')" name="name"   aria-describedby="liveFeedbackName"  v-model.lazy.trim="$v.form.name.$model" autofocus/>
           <b-form-invalid-feedback id="liveFeedbackName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Father Name" label-for="fatherName" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="fatherName" :state="validateState('fatherName')" name="fatherName"   aria-describedby="liveFeedbackFatherName"  v-model.lazy.trim="$v.form.fatherName.$model"/>
           <b-form-invalid-feedback id="liveFeedbackFatherName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="address" :state="validateState('address')" name="address"   aria-describedby="liveFeedbackAddress"  v-model.lazy.trim="$v.form.address.$model"/>
           <b-form-invalid-feedback id="liveFeedbackAddress">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Phone Number" label-for="phone" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="phone" :state="validateState('phone')" name="phone"   aria-describedby="liveFeedbackPhone"  v-model.lazy.trim="$v.form.phone.$model"/>
           <b-form-invalid-feedback id="liveFeedbackPhone">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
           <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
             Submit
           </b-button>
           <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
           <br />
         </b-col>
       </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</div>
</template>


<script>
import Vue from 'vue'
import { validationMixin } from "vuelidate";
import { required, minLength,numeric, minValue, maxLength, email,alpha,helpers } from "vuelidate/lib/validators";


const formShape = {

  name: null,
  fatherName: null,
  address: null,
  phone: null,
}
export default {
name: 'NewPatientForm',
components: {
},

data: function() {
  return {
    form: Object.assign({}, formShape),
    submitted: false,
  }
},
validations: {
  form: {
    name: {
      required
    },
    fatherName: {
      required
    },
    address: {
      required
    },
    phone: {
      required,
      numeric
    },
  }
},

methods: {
  onCancel() {
    this.$emit('cancel')
  },
  onReset() {
    this.form = formShape
    this.$nextTick(() => {
      this.$v.$reset()
    })
  },
  validate() {
    this.$v.$touch()
    return !this.$v.form.$anyError
  },
  onSubmit() {
    if (this.validate()) {
      this.$nextTick(() => {
        this.submitted = true
        let params = {
          name: this.$v.form.name.$model,
          fatherName: this.$v.form.fatherName.$model,
          address: this.$v.form.address.$model,
          phone: this.$v.form.phone.$model,
        }

        this.$store
          .dispatch('dispensary/createNewPatient', params)
          .then(response => {
            if (response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              })
            } else {
              this.showSuccessMsg({
                message: 'Record created successfully.'
              });
              let patientInfo = Object.assign({}, response.data.data);
              this.$emit('success', patientInfo);
            }

          })
          .catch(error => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else if (error.response.status == 422) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            } else {
              this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
            }
          })
      })
    }
  },
  validateState(name) {
    const { $dirty, $error } = this.$v.form[name];
    return $dirty ? !$error : null;
  },
},

created () {
},
destroyed () {
},


}

</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
